import BrandWebDemo from "./BrandWebDemo";
import AiCodeReviewDemo from "./AiCodeReviewDemo";
import EdtechDemo from "./EdtechDemo";
import BrandStorytellingDemo from "./BrandStorytellingDemo";
import AdminPageDemo from "./AdminPageDemo";
import DashboardDemo from "./DashboardDemo";

const DEMO_MAP = {
  "brand-web": BrandWebDemo,
  "ai-code-review": AiCodeReviewDemo,
  edtech: EdtechDemo,
  "brand-storytelling": BrandStorytellingDemo,
  "admin-page": AdminPageDemo,
  dashboard: DashboardDemo,
};

export function getPortfolioDemo(slug) {
  return DEMO_MAP[slug] ?? null;
}

export {
  BrandWebDemo,
  AiCodeReviewDemo,
  EdtechDemo,
  BrandStorytellingDemo,
  AdminPageDemo,
  DashboardDemo,
};
